import React from 'react'

export default function EarningsAndEstimates() {
  return (
    <div>EarningsAndEstimates</div>
  )
}
